// Widget Scripts
import sliderMainFeature from './js/widgets/mainSlider';
import mainFeatureSEOWidget from './js/widgets/mainFeatureSEOWidget';
import suscribeWidget from './js/widgets/suscribeWidget';
import activitiesWidget from './js/widgets/activitiesWidget';
import videoWidget from './js/widgets/videoWidget';
import sponsors from './js/widgets/sponsors';
import multiScheduleFeature from './js/widgets/multiScheduleFeature';
import updatesWidget from './js/widgets/updatesWidget';
import thanksSeoWidget from './js/widgets/thanksSeoWidget';
import thanksLogosWidget from './js/widgets/thanksLogosWidget';
import mealsWidget from './js/widgets/mealsWidget';

// Custom Theme Scripts
import './js/localjs';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(() => {
    sliderMainFeature();
    mainFeatureSEOWidget();
    suscribeWidget();
    activitiesWidget();
    sponsors();
    multiScheduleFeature();
    updatesWidget();
    thanksSeoWidget();
    thanksLogosWidget();
    mealsWidget();
    $(window).load(() => {
      videoWidget();
    });
  });
}
